export default function BankDataItem({ title, description }) {
  return (
    <div className="font-[poppins] text-sm ">
      <p className="text-[#252B37]font-meidum">{title}</p>
      <p className="text-[#717680] font-normal">{description}</p>
    </div>
  );
}
